// extracted by mini-css-extract-plugin
export default {"disabled":"orderData_disabled__TVIHv","order_data":"orderData_order_data__eBKqI","prcie_time":"orderData_prcie_time__btrfM","data_time":"orderData_data_time__W5vZz"};